<template>
  <div class="DarkWhite">
      <v-row row class="mt-3">
      <v-col cols="12" class="d-flex">
          <span>
            Items Issued Information (Per Stock/Property Numbers)
          </span>
          <v-divider class="mx-1 mt-3"></v-divider>
      </v-col>
      </v-row>
      <v-row>
      <v-col cols="12" sm="6" lg="3" v-for="(item, index) in cnt_items1" :key="item.text">
      <v-card elevation="0" outlined>
        <v-list-item three-line>
          <DoughnutChart class="doughnut-style" :content="item" :ref="'DoughnutChartSupply' + index*1" />
          <v-list-item-content class="ml-5">
            <v-list-item-subtitle color="#808191" class="text-subtitle-1">{{item.text}}</v-list-item-subtitle>
            <v-list-item-title class="text-h4 mb-1">
              {{parseInt(item.counter).toLocaleString()}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
      <v-col cols="12" sm="6" lg="3" v-for="(item, index) in cnt_items2" :key="item.text">
      <v-card elevation="0" outlined>
        <v-list-item three-line>
          <DoughnutChart class="doughnut-style" :content="item" :ref="'DoughnutChartSupply' + index*2" />
          <v-list-item-content class="ml-5">
            <v-list-item-subtitle color="#808191" class="text-subtitle-1">{{item.text}}</v-list-item-subtitle>
            <v-list-item-title class="text-h4 mb-1">
              {{parseInt(item.counter).toLocaleString()}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    </v-row>
    <v-row row>
      <v-col cols="12" lg="6">
        <v-card class="card-style" elevation="0" outlined>
      <v-list
      subheader
      two-line
    >
      <v-list-item-title class="text-h5 ma-5">Recent Inspected Items</v-list-item-title>

      <v-subheader class="text-h6 justify-center" v-if="recentInspected.length == 0"><i>No data available</i></v-subheader>
      <v-list-item
        v-for="(item, index) in recentInspected"
        :key="index"
      >
        <v-list-item-avatar>
          <v-icon
            class="grey lighten-2"
            color="#10578b"
            dark
          >
            mdi-text-box-check-outline
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{item.ItemName}}</v-list-item-title>

          <v-list-item-subtitle>{{item.ItemDescription}}</v-list-item-subtitle>
          <v-list-item-subtitle>
            ₱{{item.UnitCost}} | {{item.Qty}} {{item.UnitMeasureDescription + '/s'}}

          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
            <v-list-item-subtitle><small>{{item.TimeAgo}}</small></v-list-item-subtitle>
        </v-list-item-action>
      </v-list-item>
      </v-list>
    </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card class="card-style" elevation="0" outlined>
            <v-list-item three-line>
              <v-list-item-content class="ml-5">
                <v-list-item-title class="text-h5 my-2">
                  Monthly Inspection And Acceptance <small> - <b>{{mia_data.total || 0}}</b> Total IARs</small>
                </v-list-item-title>
                <v-list-item-subtitle color="#808191" class="text-subtitle-1">
                  <BarChart :content="mia_data" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card class="card-style" elevation="0" outlined>
            <v-list-item three-line>
              <v-list-item-content class="ml-5">
                <v-list-item-title class="text-h5 my-2">
                  Monthly Requisition and Issuance <small> - <b>{{mri_data.total || 0}}</b> Total RIS</small>
                </v-list-item-title>
                <v-list-item-subtitle color="#808191" class="text-subtitle-1">
                  <BarChart :content="mri_data" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card class="card-style" elevation="0" outlined>
            <v-list-item three-line>
              <v-list-item-content class="ml-5">
                <v-list-item-title class="text-h5 my-2">
                  Monthly Inventory Custodian <small> - <b>{{mic_data.total || 0}}</b> Total ICS</small>
                </v-list-item-title>
                <v-list-item-subtitle color="#808191" class="text-subtitle-1">
                  <BarChart :content="mic_data" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card class="card-style" elevation="0" outlined>
            <v-list-item three-line>
              <v-list-item-content class="ml-5">
                <v-list-item-title class="text-h5 my-2">
                  Monthly Property Acknowledgement <small> - <b>{{mpa_data.total || 0}}</b> Total PAR</small>
                </v-list-item-title>
                <v-list-item-subtitle color="#808191" class="text-subtitle-1">
                  <BarChart :content="mpa_data" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card class="card-style" elevation="0" outlined>
            <v-list-item three-line>
              <v-list-item-content class="ml-5">
                <v-list-item-title class="text-h5 my-2">
                  Monthly Return Slip <small> - <b>{{mrs_data.total || 0}}</b> Total RS</small>
                </v-list-item-title>
                <v-list-item-subtitle color="#808191" class="text-subtitle-1">
                  <BarChart :content="mrs_data" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    </div>
</template>

<script>
import BarChart from "../Charts/BarChart.vue";
import DoughnutChart from "../Charts/DoughnutChart.vue";
export default {
  components: {
      BarChart,
      DoughnutChart,
    },
  props: {
    fiscalYear: null
  },
  data: () => ({
    cnt_items1: [
      {
        colors: "green darken-1",
        icon: "mdi-clipboard-check",
        text: "Stocks",
        counter: 0,
        label: ["Stocks", "Total"],
        chartType: 1
      },
      {
        colors: "orange darken-1",
        icon: "mdi-clipboard-clock",
        text: "Semi-Expendable Properties",
        counter: 0,
        label: ["Semi-Expendable Properties", "Total"],
        chartType: 2
      },
    ],
    cnt_items2: [
      {
        colors: "blue darken-1",
        icon: "mdi-clipboard-check",
        text: "Properties",
        counter: 0,
        label: ["Properties", "Total"],
        chartType: 3
      },
      {
        colors: "red darken-1",
        icon: "mdi-clipboard-clock",
        text: "Returned Items",
        counter: 0,
        label: ["Returned Items", "Total"],
        chartType: 4
      },
    ],
    labels_pr: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    value_pr: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    prChartData_count: 0,
    recentInspected: [],
    mpr_data: [],
    mpo_data: [],
    mia_data: [],
    mri_data: [],
    mic_data: [],
    mpa_data: [],
    mrs_data: [],
  }),
watch: {
    fiscalYear: {
      handler(data) {
        this.$store.dispatch("setFiscalYear", data);
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      //this.getBudgetMonitoring();
      if(this.fiscalYear != null){
        this.recentInspection();
        this.iarChartData();
        this.risicsparrsChartData();
        this.supplyCounts();
      }
    },
    // getBudgetMonitoring() {
    //   let data = new FormData();
    //   if (this.options.page) {
    //     data.append("page", this.options.page);
    //     data.append("itemsPerPage", this.options.itemsPerPage);
    //   } else {
    //     data.append("page", 1);
    //     data.append("itemsPerPage", 10);
    //   }
    //   data.append("searchText", this.searchText);
    //   this.axiosCall("/dashboard/budgetMonitoring", "POST", data).then(
    //     (res) => {
    //       this.loading = false;
    //       this.budgetMonitoringData = res.data.data.result;
    //       this.totalCount = res.data.data.total;
    //       if (this.totalCount <= 10) {
    //         this.options.page = 1;
    //       }
    //     }
    //   );
    // },
    // prChartData(){
    //   let data = new FormData();
    //   data.append('fiscalYear', this.fiscalYear)
    //   this.axiosCall("/dashboard/prChartData", "POST", data).then(
    //     (res) => {
    //       this.loading = false;
    //       let labels = [];
    //       let data = [];
    //       let total = 0;
    //       res.data.data.result.forEach(item => {
    //         labels.push(item.monthname + " " + item.year);
    //       });
    //       res.data.data.result.forEach(item => {
    //         data.push(item.totalcount);
    //         total = total + parseInt(item.totalcount);
    //       });
    //       this.mpr_data = {
    //         labels: labels,
    //         data: data,
    //         total: total,
    //         label: 'No. of Purchase Request',
    //       }
    //     }
    //   );
    // },
    recentInspection(){
      let data = new FormData();
      data.append('fiscalYear', this.fiscalYear)
      this.axiosCall("/dashboard/recentInspections", "POST", data).then(
        (res) => {
          this.loading = false;
          this.recentInspected = res.data.data.result
        }
      );
    },
    supplyCounts(){
      let data = new FormData();
      data.append('fiscalYear', this.fiscalYear)
      this.axiosCall("/dashboard/supplyCounts", "POST", data).then(
        (res) => {
          this.loading = false;
          this.cnt_items1[0].counter = res.data.data.result.sc || 0.01;
          this.cnt_items1[1].counter = res.data.data.result.sp || 0.01;
          this.cnt_items2[0].counter = res.data.data.result.pc || 0.01;
          this.cnt_items2[1].counter = res.data.data.result.ri || 0.01;
        }
      );
    },
    iarChartData(){
      let data = new FormData();
      data.append('fiscalYear', this.fiscalYear)
      this.axiosCall("/dashboard/iarChartData", "POST", data).then(
        (res) => {
          this.loading = false;
          let labels = [];
          let data = [];
          let total = 0;
          res.data.data.result.forEach(item => {
            labels.push(item.monthname + " " + item.year);
          });
          res.data.data.result.forEach(item => {
            data.push(item.totalcount);
            total = total + parseInt(item.totalcount);
          });
          this.mia_data = {
            labels: labels,
            data: data,
            total: total,
            label: 'No. of Inspection And Acceptance Receipt',
            bgColor: '#686868',
          }
        }
      );
    },
    risicsparrsChartData(){
      let data = new FormData();
      data.append('fiscalYear', this.fiscalYear)
      this.axiosCall("/dashboard/risicsparrsChartData", "POST", data).then(
        (res) => {
          this.loading = false;
          let labels_ris = [];
          let data_ris = [];
          let total_ris = 0;
          res.data.data.result.ris.forEach(item => {
            labels_ris.push(item.monthname + " " + item.year);
          });
          res.data.data.result.ris.forEach(item => {
            data_ris.push(item.totalcount);
            total_ris = total_ris + parseInt(item.totalcount);
          });
          this.mri_data = {
            labels: labels_ris,
            data: data_ris,
            total: total_ris,
            label: 'No. of Requisition And Issuance Slip',
            bgColor: '#3B82F6',
          }

          let labels_ics = [];
          let data_ics = [];
          let total_ics = 0;
          res.data.data.result.ics.forEach(item => {
            labels_ics.push(item.monthname + " " + item.year);
          });
          res.data.data.result.ics.forEach(item => {
            data_ics.push(item.totalcount);
            total_ics = total_ics + parseInt(item.totalcount);
          });
          this.mic_data = {
            labels: labels_ics,
            data: data_ics,
            total: total_ics,
            label: 'No. of Inventory Custodian Slip',
            bgColor: '#10B981',
          }

          let labels_par = [];
          let data_par = [];
          let total_par = 0;
          res.data.data.result.par.forEach(item => {
            labels_par.push(item.monthname + " " + item.year);
          });
          res.data.data.result.par.forEach(item => {
            data_par.push(item.totalcount);
            total_par = total_par + parseInt(item.totalcount);
          });
          this.mpa_data = {
            labels: labels_par,
            data: data_par,
            total: total_par,
            label: 'No. of Property Acknowledgement Receipt',
            bgColor: '#F59E0B',
          }

          let labels_rs = [];
          let data_rs = [];
          let total_rs = 0;
          res.data.data.result.rs.forEach(item => {
            labels_rs.push(item.monthname + " " + item.year);
          });
          res.data.data.result.rs.forEach(item => {
            data_rs.push(item.totalcount);
            total_rs = total_rs + parseInt(item.totalcount);
          });
          this.mrs_data = {
            labels: labels_rs,
            data: data_rs,
            total: total_rs,
            label: 'No. of Return Slip',
            bgColor: '#EF4444',
          }
        }
      );
    },
    getFiscalYears() {
      this.fiscalyears = [{id: 0, fiscalYear: "All"}]
      this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
        this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
        this.fiscalYear = this.$store.state.fiscalYear != null ? this.$store.state.fiscalYear : res.data.data[0].id
      });
    },
  },
};
</script>

<style scoped>
.Offset {
  top: -20px !important;
  position: relative !important;
}
.v-sheet--offset {
  top: -15px;
  position: relative;
}
</style>
